/* Progressive enhancement: product and collection links work without JavaScript. */
if (!customElements.get('sizmari-archive')) {
  customElements.define('sizmari-archive', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.filters = [...this.querySelectorAll('[data-sz-filter]')];
      this.tiles = [...this.querySelectorAll('[data-sz-groups]')];
      this.preview = this.querySelector('[data-sz-preview]');
      this.previewImage = this.querySelector('[data-sz-preview-image]');
      this.previewCaption = this.querySelector('[data-sz-preview-caption]');
      this.status = this.querySelector('[data-sz-status]');
      this.onFilter = (filter) => {
        const key = filter.dataset.szFilter;
        this.filters.forEach(link => {
          if (link === filter) link.setAttribute('aria-current', 'true');
          else link.removeAttribute('aria-current');
        });
        let count = 0;
        this.tiles.forEach(tile => {
          tile.hidden = key !== 'all' && !tile.dataset.szGroups.split('|').includes(key);
          if (!tile.hidden) count++;
        });
        this.activeTile = null;
        this.preview.hidden = true;
        this.status.textContent = `${count} ${count === 1 ? 'work' : 'works'}${key === 'all' ? '' : ' in ' + filter.textContent.trim()}`;
      };
      this.filters.forEach(filter => filter.addEventListener('click', event => {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
        event.preventDefault();
        this.onFilter(filter);
      }, options));
      /* Hover preview: shows every photo of the hovered listing in turn. */
      const interval = Math.max(400, parseInt(this.dataset.szInterval, 10) || 900);
      const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)');
      const preloaded = new Set();
      const stopCycle = () => { clearInterval(this.cycleTimer); this.cycleTimer = null; };
      this.stopCycle = stopCycle;
      const hide = () => { stopCycle(); this.activeTile = null; this.preview.hidden = true; };
      const showSrc = (tile, src) => {
        if (this.activeTile !== tile) return;
        this.previewImage.src = src;
        if (this.previewImage.complete && this.previewImage.naturalWidth) this.preview.hidden = false;
      };
      const show = tile => {
        if (this.activeTile === tile && !this.preview.hidden) return;
        stopCycle();
        this.activeTile = tile;
        if (!tile.dataset.szImage || !matchMedia('(min-width: 601px)').matches) {
          hide();
          return;
        }
        const photos = (tile.dataset.szImages || tile.dataset.szImage).split('|').filter(Boolean);
        photos.forEach(src => {
          if (preloaded.has(src)) return;
          preloaded.add(src);
          const img = new Image();
          img.decoding = 'async';
          img.src = src;
        });
        this.preview.hidden = true;
        this.previewCaption.textContent = tile.dataset.szTitle;
        let index = 0;
        showSrc(tile, photos[0]);
        if (photos.length > 1 && !reduceMotion.matches) {
          this.cycleTimer = setInterval(() => {
            if (this.activeTile !== tile) { stopCycle(); return; }
            index = (index + 1) % photos.length;
            showSrc(tile, photos[index]);
          }, interval);
        }
      };
      this.previewImage.addEventListener('load', () => {if (this.activeTile) this.preview.hidden = false;}, options);
      this.previewImage.addEventListener('error', () => {if (!this.cycleTimer) this.preview.hidden = true;}, options);
      this.tiles.forEach(tile => {
        tile.addEventListener('pointerenter', event => {if (event.pointerType !== 'touch') show(tile);}, options);
        tile.addEventListener('focus', () => show(tile), options);
      });
      this.querySelector('.sz-grid').addEventListener('pointerleave', () => {
        if (!this.tiles.includes(document.activeElement)) hide();
      }, options);
      this.addEventListener('focusout', event => {
        if (!this.tiles.includes(event.relatedTarget)) hide();
      }, options);
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape') hide();
      }, options);
      /* Links from the inner pages arrive as /?c=<collection-handle>: open with that group selected. */
      let start = this.filters[0];
      try {
        const wanted = new URLSearchParams(window.location.search).get('c');
        if (wanted) {
          const match = this.filters.find(link => (link.getAttribute('href') || '').split('?')[0].replace(/\/$/, '').endsWith('/collections/' + wanted));
          if (match) start = match;
        }
      } catch (e) { /* ignore */ }
      if (start) this.onFilter(start);
    }
    disconnectedCallback() {this.stopCycle?.(); this.controller?.abort(); this.controller = null;}
  });
}
